import React from 'react';

const Footer = () => {
	return <div className="footer">&copy; 2021 DOTMANDALORIAN ALL RIGHTS RESERVED</div>;
};

export default Footer;
